module.exports = __webpack_public_path__ + "img/2-settings.5d7073bb.svg";